// extracted by mini-css-extract-plugin
export default {"categorySelect":"categorySelect--mp-zo6XJ"};